import React, { FC } from 'react';
import styles from './index.module.scss';
import Categories from './Categories';
import BackToButton from 'src/shared/TenderNav/BackToButton';
import { NavMenu, NavMenuLinks } from 'src/common';

export const TenderNav: FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <NavMenu>
          <NavMenuLinks>
            <BackToButton />
          </NavMenuLinks>
        </NavMenu>
        <Categories />
      </div>
    </div>
  );
};

export default TenderNav;
